<template>
  <div>
    <Movementmenu />
    <v-container fluid class="grey lighten-4">
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-account-switch"
            title="ระบบบริหารจัดการรายละเอียดผู้ขอย้าย (ประมวลผลแบบที่ 1)"
            color="primary"
          >
            <v-row class="px-4 py-2">
              <v-col cols="12" md="3" v-for="(stat, i) in statistics" :key="i">
                <v-card outlined class="rounded-lg">
                  <v-list-item three-line>
                    <v-list-item-content>
                      <div class="overline mb-4">{{ stat.title }}</div>
                      <v-list-item-title class="headline mb-1 font-weight-bold">
                        {{ stat.value }} <small>ราย</small>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-avatar size="60" :color="stat.color + ' lighten-4'">
                      <v-icon :color="stat.color" size="30">{{
                        stat.icon
                      }}</v-icon>
                    </v-avatar>
                  </v-list-item>
                </v-card>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <v-row class="px-4">
              <v-col
                cols="12"
                md="8"
                class="d-flex align-center flex-wrap"
                style="gap: 10px;"
              >
                <v-btn
                  depressed
                  color="primary"
                  dark
                  rounded
                  :href="reportLinks.raw"
                  target="_blank"
                >
                  <v-icon left>mdi-file-document-outline</v-icon>
                  รายงานข้อมูลดิบ
                </v-btn>
                <v-btn
                  depressed
                  color="info"
                  dark
                  rounded
                  :href="reportLinks.additional"
                  target="_blank"
                >
                  <v-icon left>mdi-file-plus-outline</v-icon> รายงานเพิ่มเติม
                </v-btn>
                <v-btn
                  depressed
                  color="info"
                  dark
                  rounded
                  :href="reportLinks.vacant"
                  target="_blank"
                >
                  <v-icon left>mdi-account-group-outline</v-icon>
                  รายงานอัตราว่าง
                </v-btn>
                <v-btn
                  depressed
                  color="warning darken-2"
                  dark
                  rounded
                  :href="reportLinks.score"
                  target="_blank"
                >
                  <v-icon left>mdi-format-list-numbered</v-icon> แบบบันทึกคะแนน
                  (7)
                </v-btn>
              </v-col>
              <v-col cols="12" md="4" class="text-right">
                <v-btn
                  depressed
                  color="error"
                  rounded
                  @click="search_not_confirm_submit"
                >
                  <v-icon left>mdi-account-search</v-icon>
                  รายการที่ยังไม่ได้บันทึก
                </v-btn>
              </v-col>
            </v-row>
          </base-material-card>
        </v-col>
      </v-row>

      <v-card class="mt-4 rounded-lg shadow-sm">
        <v-card-title class="pa-4">
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="ค้นหาชื่อ, รหัสบัตร, หรือสถานศึกษา..."
                outlined
                dense
                hide-details
                class="rounded-lg"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="selectedHeaders"
                :items="headers"
                label="ปรับแต่งคอลัมน์"
                multiple
                outlined
                dense
                hide-details
                return-object
                class="rounded-lg"
              >
                <template v-slot:selection="{ index }">
                  <span v-if="index === 0" class="grey--text caption">
                    เลือกแสดง {{ selectedHeaders.length }} คอลัมน์
                  </span>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table
          :loading="loading"
          :headers="showHeaders"
          :items="transference_locations"
          :search="search"
          class="elevation-0 custom-table"
        >
          <template v-slot:item="{ item, index }">
            <tr>
              <td>
                <v-checkbox
                  v-model="search_college"
                  :value="item.tlcollege_code"
                  hide-details
                  dense
                ></v-checkbox>
              </td>
              <td class="text-center font-weight-bold">{{ index + 1 }}</td>
              <td>
                <div class="font-weight-medium">
                  {{ item.title_s }}{{ item.frist_name }} {{ item.last_name }}
                </div>
                <small class="grey--text">{{ item.id_card }}</small>
              </td>
              <td class="text-center grey lighten-5">
                <v-chip small outlined>{{ item.college_code_now }}</v-chip>
                <div>
                  {{ item.college_name_now }}
                </div>
                <div class="caption">{{ item.provinceNow }}</div>
              </td>
              <td class="text-center info lighten-5">
                <div class="font-weight-bold info--text text--darken-4">
                  {{ item.tlcollege_code }}
                </div>
                <div>
                  {{ item.user_firstname }}
                </div>
                <div class="caption">{{ item.provinceNew }}</div>
              </td>
              <td class="text-center">
                <v-chip
                  v-if="item.status_position"
                  color="success"
                  x-small
                  dark
                  >{{ item.status_position }}</v-chip
                >
                <v-icon v-else color="error">mdi-close-circle-outline</v-icon>
              </td>
              <td class="text-center">{{ item.tlsequence_n }}</td>
              <td class="text-center">
                <v-chip
                  :color="getStatusColor(item.status_select, item.succ_college)"
                  dark
                  small
                  class="font-weight-bold"
                  @click="handleAction(item)"
                >
                  <v-icon left small>{{
                    getStatusIcon(item.status_select, item.succ_college)
                  }}</v-icon>
                  {{ getStatusText(item.status_select, item.succ_college) }}
                </v-chip>
              </td>
              <td class="text-center">
                <div
                  v-if="item.college_name_suss"
                  class="success--text font-weight-bold"
                >
                  {{ item.college_name_suss }}
                  <div class="caption grey--text">
                    เลขที่: {{ item.id_position_new }}
                  </div>
                </div>
                <span v-else class="grey--text italic">-- รอดำเนินการ --</span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="positiondialog" persistent max-width="900px">
        <v-card class="rounded-xl overflow-hidden">
          <v-toolbar flat color="warning darken-2" dark>
            <v-icon left>mdi-card-search-outline</v-icon>
            <v-toolbar-title>พิจารณาจัดสรรตำแหน่งที่รับย้าย</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="positiondialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>

          <v-card-text class="pa-6">
            <v-row>
              <v-col cols="12" md="6">
                <v-card outlined class="pa-4 fill-height">
                  <div class="overline primary--text">
                    ข้อมูลผู้ขอรับการย้าย
                  </div>
                  <h3 class="mt-2">
                    {{ transference_personnels_id_ref.title_s
                    }}{{ transference_personnels_id_ref.frist_name }}
                    {{ transference_personnels_id_ref.last_name }}
                  </h3>
                  <v-list dense>
                    <v-list-item class="px-0">
                      <v-list-item-icon
                        ><v-icon small
                          >mdi-office-building</v-icon
                        ></v-list-item-icon
                      >
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >สังกัดปัจจุบัน</v-list-item-subtitle
                        >
                        <v-list-item-title>{{
                          transference_personnels_id_ref.college_name
                        }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="px-0">
                      <v-list-item-icon
                        ><v-icon small>mdi-numeric</v-icon></v-list-item-icon
                      >
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >ตำแหน่งเดิมเลขที่</v-list-item-subtitle
                        >
                        <v-list-item-title>{{
                          transference_personnels_id_ref.id_position
                        }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>

              <v-col cols="12" md="6">
                <v-card
                  outlined
                  class="pa-4 fill-height accent--lighten-5"
                  color="info lighten-5"
                >
                  <div class="overline info--text">เหตุผลความจำเป็น</div>
                  <div v-for="n in 4" :key="n">
                    <div
                      v-if="
                        transference_personnels_id_ref['reason_' + n] === '1' ||
                        transference_personnels_id_ref['reason_' + n] === 1
                      "
                      class="mt-2"
                    >
                      <v-chip color="info" small class="mb-1">{{
                        getReasonTitle(n)
                      }}</v-chip>
                      <div class="caption ml-2 font-italic">
                        {{ getReasonDetail(n) }}
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>

              <v-col cols="12">
                <v-alert
                  colored-border
                  border="left"
                  color="primary"
                  elevation="1"
                  class="mb-0"
                >
                  <div class="d-flex justify-space-between align-center">
                    <div>
                      <div class="caption">
                        สถานศึกษาที่ต้องการย้ายไป (ลำดับ
                        {{ transference_location_s.tlsequence_n }})
                      </div>
                      <h3 class="primary--text">
                        {{ transference_location_s.tlcollege_code }} -
                        {{ transference_location_s.college_name }}
                      </h3>
                      <div class="subtitle-2">
                        สาขาวิชา: {{ transference_location_s.name_branch }}
                      </div>
                    </div>
                    <v-avatar color="primary" size="48"
                      ><v-icon dark>mdi-map-marker-check</v-icon></v-avatar
                    >
                  </div>
                </v-alert>
              </v-col>

              <v-col cols="12">
                <v-form ref="updatepositionform" v-model="valid">
                  <v-autocomplete
                    v-model="updatepositions.id_position"
                    :items="man_powers"
                    item-text="college_position_case"
                    item-value="id_position"
                    label="เลือกเลขที่ตำแหน่งว่างเพื่อจัดสรร"
                    prepend-inner-icon="mdi-account-details"
                    outlined
                    class="rounded-lg mt-4"
                    required
                    :rules="[v => !!v || 'กรุณาเลือกตำแหน่ง']"
                  ></v-autocomplete>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions class="pa-4 grey lighten-4">
            <v-spacer></v-spacer>
            <v-btn text @click="positiondialog = false" class="px-6"
              >ยกเลิก</v-btn
            >
            <v-btn
              color="success"
              @click="updatepositionSubmit"
              depressed
              class="px-8 rounded-lg"
              large
            >
              <v-icon left>mdi-content-save</v-icon> ยืนยันการจัดสรรตำแหน่ง
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbar.show" :color="snackbar.color" bottom right>
        <v-icon left>{{ snackbar.icon }}</v-icon>
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Movementmenu from "../../components/admin/movementmenu.vue";

export default {
  components: { Movementmenu },
  data() {
    return {
      loading: false,
      ApiKey: "HRvec2021",
      search: "",
      search_college: [],
      valid: true,
      positiondialog: false,
      canceldialog: false,
      snackbar: { show: false, color: "success", icon: "mdi-check", text: "" },

      transference_locations: [],
      transference_location_s: {},
      transference_personnels_id_ref: {},
      periods: {},
      man_powers: [],
      updatepositions: {},
      addreturn_man_power: {},
      updatepositions_condition: {},
      position: "ครู",

      headersMap: [
        {
          text: "เลือก",
          align: "center",
          value: "select_item",
          sortable: false
        },
        { text: "#", align: "center", value: "index" },
        { text: "ข้อมูลผู้ขอย้าย", align: "left", value: "frist_name" },
        { text: "สังกัดเดิม", align: "center", value: "college_code_now" },
        { text: "ปลายทางที่ต้องการ", align: "center", value: "tlcollege_code" },
        { text: "สถานะ", align: "center", value: "status_position" },
        { text: "ลำดับ", align: "center", value: "tlsequence_n" },
        {
          text: "การจัดการ",
          align: "center",
          value: "actions",
          sortable: false
        },
        { text: "ผลการจัดสรร", align: "center", value: "college_name_suss" }
      ],
      selectedHeaders: [],
      headers: []
    };
  },

  computed: {
    showHeaders() {
      return this.headers.filter(s => this.selectedHeaders.includes(s));
    },
    statistics() {
      const total = this.transference_locations.length;
      const success = this.transference_locations.filter(
        i => i.succ_college >= 1
      ).length;
      return [
        {
          title: "ผู้ขอย้ายทั้งหมด",
          value: total,
          icon: "mdi-account-group",
          color: "primary"
        },
        {
          title: "จัดสรรสำเร็จ",
          value: success,
          icon: "mdi-check-decagram",
          color: "success"
        },
        {
          title: "รอดำเนินการ",
          value: total - success,
          icon: "mdi-clock-outline",
          color: "warning"
        },
        {
          title: "ยกเลิก/ไม่สมบูรณ์",
          value: 0,
          icon: "mdi-alert-circle",
          color: "error"
        }
      ];
    },
    reportLinks() {
      const { period_times, period_year } = this.periods;
      const base = `#/admin/print_report_`;
      return {
        raw: `${base}movement_online/${period_times}/${period_year}/teach`,
        additional: `${base}movement_online_2/${period_times}/${period_year}/teach`,
        vacant: `${base}condition_all/${period_times}/${period_year}`,
        score: `${base}movement_formscore7/?period_times=${period_times}&period_year=${period_year}`
      };
    }
  },

  async created() {
    this.headers = Object.values(this.headersMap);
    this.selectedHeaders = this.headers;
  },

  async mounted() {
    await this.periodQuery();
    await this.transference_locationQueryAll();
  },

  methods: {
    async search_not_confirm_submit() {
      this.loading = true;
      let result = await this.$http
        .post("transference_location.php", {
          ApiKey: this.ApiKey,
          time_s: this.times_select,
          year_s: this.years_select,
          not_confirm: "ok"
        })
        .finally(() => (this.loading = false));
      this.transference_locations = result.data;
    },
    
    // --- API Methods (คงเดิมแต่ปรับปรุงการแจ้งเตือน) ---
    async periodQuery() {
      let res = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_enable_process: "1",
        period_id: "301"
      });
      this.periods = res.data;
    },

    async transference_locationQueryAll() {
      this.loading = true;
      try {
        let res = await this.$http.post("transference_location.php", {
          ApiKey: this.ApiKey,
          time_s: this.periods.period_times,
          year_s: this.periods.period_year
        });
        this.transference_locations = res.data;
      } finally {
        this.loading = false;
      }
    },

    async select_idPosition(tid_ref, id_tfl) {
      let res_person = await this.$http.post("transference_personnel.php", {
        ApiKey: this.ApiKey,
        id_ref: tid_ref
      });
      this.transference_personnels_id_ref = res_person.data;

      let res_loc = await this.$http.post("transference_location.php", {
        ApiKey: this.ApiKey,
        id_tfl: id_tfl
      });
      this.transference_location_s = res_loc.data;

      this.updatepositions = {};
      await this.man_powerQuery();
      this.positiondialog = true;
    },

    async man_powerQuery() {
      let res = await this.$http.post("man_power_process.php", {
        ApiKey: this.ApiKey,
        college_code: this.transference_location_s.tlcollege_code
      });
      this.man_powers = res.data;
    },

    async updatepositionSubmit() {
      if (this.$refs.updatepositionform.validate()) {
        // เตรียมข้อมูล (Mapping Logic เดิม)
        const payload = {
          ApiKey: this.ApiKey,
          ...this.updatepositions,
          id_card: this.transference_personnels_id_ref.id_card,
          id_ref: this.transference_personnels_id_ref.tid_ref,
          college_code: this.transference_location_s.tlcollege_code,
          status_select: "demand"
          // ... อื่นๆ ตาม API เดิม
        };

        // แสดง Loading ด้วย SweetAlert2
        Swal.fire({
          title: "กำลังบันทึก...",
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading()
        });

        try {
          // จำลองการเรียก API ตามลำดับในโค้ดเดิม
          let res = await this.$http.post(
            "conditons_transfer_success.insert.php",
            payload
          );
          if (res.data.status) {
            this.showSnackbar("บันทึกข้อมูลเรียบร้อย", "success");
            this.positiondialog = false;
            await this.transference_locationQueryAll();
            Swal.close();
          }
        } catch (e) {
          Swal.fire("ผิดพลาด", "ไม่สามารถบันทึกได้", "error");
        }
      }
    },

    // --- UI Helpers ---
    handleAction(item) {
      if (item.succ_college >= 1) {
        this.deletePosition(item.tid_ref);
      } else {
        this.select_idPosition(item.tid_ref, item.id_tfl);
      }
    },

    getStatusColor(status, success) {
      if (success >= 1) return "success";
      if (status === "agree") return "amber darken-2";
      if (status === "sw_normal") return "deep-orange";
      return "blue-grey lighten-1";
    },

    getStatusIcon(status, success) {
      if (success >= 1) return "mdi-check-circle";
      return "mdi-credit-card-plus";
    },

    getStatusText(status, success) {
      if (success >= 1) return "จัดสรรแล้ว";
      if (status === "agree") return "ปกติ (2)";
      if (status === "sw_normal") return "สับเปลี่ยน (3)";
      return "เลือกตำแหน่ง";
    },

    getReasonTitle(n) {
      const titles = [
        "",
        "ย้ายเพื่ออยู่ร่วมคู่สมรส",
        "ย้ายดูแลบิดามารดา",
        "ย้ายกลับภูมิลำเนา",
        "เหตุผลอื่นๆ"
      ];
      return titles[n];
    },

    getReasonDetail(n) {
      const d = this.transference_personnels_id_ref;
      if (n === 1)
        return `คู่สมรส: ${d.reason_1_spouse || "-"} (${d.r1_province})`;
      if (n === 2)
        return `บิดาอายุ: ${d.reason_2_fyear} ปี / มารดา: ${d.reason_2_myear} ปี`;
      if (n === 3) return `จังหวัด: ${d.r3_province}`;
      if (n === 4) return d.reason_4_detail;
      return "";
    },

    showSnackbar(text, color = "success") {
      this.snackbar = {
        show: true,
        text,
        color,
        icon: color === "success" ? "mdi-check" : "mdi-alert"
      };
    }
  }
};
</script>

<style scoped>
.custom-table >>> thead th {
  background-color: #f8f9fa !important;
  font-weight: 600 !important;
  color: #455a64 !important;
  text-transform: uppercase;
  font-size: 0.75rem !important;
}
.custom-table >>> tbody tr:hover {
  background-color: #f5f5f5 !important;
}
.shadow-sm {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
}
</style>
